document.addEventListener('DOMContentLoaded', function() {
    customElements.define("item-slider", class extends HTMLElement {
        constructor() {
            super();
            this.initSwiper();
        }

        initSwiper() {

            const additionalConfig = this.dataset.config ? JSON.parse(this.dataset.config) : {};

            const config = {
                slidesPerView: parseInt(this.dataset.largeView || 3, 10),
                spaceBetween: 30,
                loop: this.dataset.loop !== 'false',
                centeredSlides: this.dataset.centeredSlides !== 'false',
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },

            };

            if (this.dataset.pagination !== 'false') {
                config.pagination = {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: true
                };
            }

            if (this.dataset.navigation !== 'false') {
                config.navigation = {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                };
            }

            Object.assign(config, additionalConfig);

            new Swiper(this.querySelector('.swiper'), config);
        }
    });
});